import React from 'react';

const CustomSwitcher = (props) => (
  <>
   
  </>
);

export default CustomSwitcher;